"use strict";

var _regeneratorRuntime = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/regenerator/index.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDeliveryTimes = void 0;
var APIUrl_DELIVERY_TIMES = "/api/items/v1/public/delivery-times";

var getDeliveryTimes = function getDeliveryTimes(requestBody, axiosInstance) {
  var handleSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  var handleOnFail = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
  var cancelTokenObject = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axiosInstance.post("".concat(APIUrl_DELIVERY_TIMES), requestBody, cancelTokenObject).then(handleSuccess).catch(handleOnFail);

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

exports.getDeliveryTimes = getDeliveryTimes;